var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSvs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1162 24.965H12.8887C6.27057 24.965 0.90625 19.5772 0.90625 12.9302C0.90625 6.28326 6.27057 0.895508 12.8887 0.895508H18.1162C14.2985 3.5223 11.7942 7.93207 11.7942 12.9302C11.7942 17.9284 14.2985 22.3382 18.1162 24.965ZM20.7672 14.0832H25.9947C32.6128 14.0832 37.9771 19.471 37.9771 26.118C37.9771 32.765 32.6128 38.1527 25.9947 38.1527H20.7672C24.5848 35.5259 27.0892 31.1162 27.0892 26.118C27.0892 21.1198 24.5848 16.71 20.7672 14.0832ZM37.8971 11.7898C37.2211 5.78613 32.1497 1.12095 25.9919 1.12095C19.8341 1.12095 14.7643 5.78613 14.0868 11.7898H37.8971ZM12.8114 38.1652C6.65362 38.1652 1.58222 33.5 0.90625 27.4964H24.7166C24.039 33.5 18.9692 38.1652 12.8114 38.1652Z",
    fill: "#F2F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvs);
export default __webpack_public_path__ + "static/media/logo-svs.3d136a2bab958b2c1f9cd812cbb52086.svg";
export { ForwardRef as ReactComponent };